import type {AppError, Result} from '@packages/utils/src';
import type * as z from 'zod';
import {DEFAULT_API_VERSION} from '../../config/apiVersion';
import {defaultClient} from '../../lib/defaultClient';
import {createPathWithQuery} from '../../shared/services/createPathWithQuery';
import {
  type GetSearchKeywordRepositoryProps,
  GetSearchKeywordResponse,
} from '../entities/search/schema';

export type GetSearchKeywordResponseType = z.infer<
  typeof GetSearchKeywordResponse
>;

type ReturnSearchResultValueType = Result<
  GetSearchKeywordResponseType,
  AppError
>;

export const getSearchKeyword = async (
  keyword: string,
  typeString = '',
  page = 1,
  version = DEFAULT_API_VERSION,
): Promise<ReturnSearchResultValueType> => {
  const params: {
    q: string;
    type: string;
    page: number;
  } = {
    q: keyword,
    type: typeString,
    page,
  };
  const path = createPathWithQuery(`/${version}/search/keyword`, params);
  const result: ReturnSearchResultValueType = await defaultClient.get(
    path,
    GetSearchKeywordResponse,
  );
  if (!result?.ok) {
    throw new Error(result.error);
  }

  return result;
};

export const getSearchKeywordRepository = async ({
  keyword,
  typeString = '',
  page = 1,
}: GetSearchKeywordRepositoryProps): Promise<ReturnSearchResultValueType> => {
  return getSearchKeyword(keyword, typeString, page);
};
